import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";
import { APIURL } from "./../../constants";
import services from "./../../components/services";
import { DefaultLayout } from "../../layouts";
import Image from "next/image";
import Head from 'next/head'
import { useRouter } from 'next/router'
import { faqPathSlug } from '../../utils/faqUrls'

// class Blog extends React.Component {
export default function FAQs({ data, page }) {
  const router = useRouter();
	let parsed = JSON.parse(data);
	let faqs = [];
  console.log(parsed)
	if (parsed && parsed.results) {
		for (const post in parsed.results) {
      console.log(post)
			const faq = parsed.results[post];
      console.log(faq)
      if (faq) {
        console.log(faq)
  			const pathSlug = faq.path_slug || faqPathSlug(faq["question"]);
  			faqs.push(
  				<Link
  					className="blog-card"
  					key={"blog-post-" + post}
  					title={faq["question"]}
  					href={{
  						pathname: `/FAQs/${pathSlug}`,
  					}}
  				>
  					<div className="blog-title">{faq["question"]}</div>
            <div className="bottom-split">
    					<div className="blog-created">{faq["created_at"]}</div>
              <div className="blog-topic">{faq["topic_name"]}</div>
            </div>
  				</Link>
  			);
  		}
    }
	}

  const handlePagination = (newPage) => {
    router.push(`/FAQs?page=${newPage}`);
  };
	// render () {
	return (
		<div className="home">
      <Head>
        <title>SimplyBuy | FAQs</title>
        <meta name='description' content={"Answers that lead to better buys — then jump into SimplyBuy’s free product pickers for snowboards, TVs, headphones, skis, and more."}/>
      </Head>
			<div className="home-container">
				<h1 className="blog-index-title">SimplyBuy FAQs</h1>
				<div className="blog-index">{faqs}</div>
        <div className="pagination-controls">
          <button
            onClick={() => handlePagination(page - 1)}
            disabled={parsed.previous === null} // Disable if there's no previous page
          >
            Previous
          </button>
          <span>Page {page}</span>
          <button
            onClick={() => handlePagination(page + 1)}
            disabled={parsed.next === null} // Disable if there's no next page
          >
            Next
          </button>
        </div>
			</div>
		</div>
	);
	// }
}

export async function getServerSideProps(context) {
  const page = context.query.page || 1
	const response = await services.get_v2(APIURL.GET_FAQS, { params: { page } });
	const data = JSON.stringify(response);
	return { props: { data, page: parseInt(page) } };
}
